<script>
    import { onMount, afterUpdate } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    import { graphDataStore } from './stores';
  
    const dispatch = createEventDispatcher();
    let searchInput = '';
    let usernames = [];
    let filteredUsernames = [];
    let searchInputElement;
  
    onMount(() => {
        const unsubscribe = graphDataStore.subscribe((graphData) => {
            usernames = graphData.nodes.map(node => node.id);
            filteredUsernames = usernames;
            searchInputElement.focus();
        });

        return () => {
            // Unsubscribe from the store on component unmount
            unsubscribe();
        };
      
    });
  
    afterUpdate(() => {
      if (filteredUsernames.length === 1) {
        handleUsernameSelect(filteredUsernames[0]);
      }
    });
  
    function handleInputChange(event) {
      searchInput = event.target.value;
      filterUsernames();
    }
  
    function filterUsernames() {
      filteredUsernames = usernames.filter(username =>
        username.toLowerCase().includes(searchInput.toLowerCase())
      );
    }
  
    function handleUsernameSelect(username) {
      searchInput = username;
      filterUsernames();
      dispatch('usernameSelected', username);
    }
  </script>
  
  <div class="relative">
    <input
      type="text"
      value={searchInput}
      on:input={handleInputChange}
      placeholder="Search for username"
      class="w-full px-3 py-2 rounded shadow"
      list="usernameList"
      bind:this={searchInputElement}
    />
  
    {#if filteredUsernames.length > 0}
      <datalist id="usernameList" class="mt-1 bg-white rounded-lg shadow-lg">
        {#each filteredUsernames as username}
          <option value={username} class="py-2 px-4 cursor-pointer hover:bg-purple-blue focus:bg-purple-blue" />
        {/each}
      </datalist>
    {/if}
  </div>
  